import { Component, Input } from '@angular/core'
import { Price } from '@spartacus/core'

@Component({
  selector: 'mb-submit-order-request',
  templateUrl: './mb-submit-order-request.component.html',
})
export class MbSubmitOrderRequestComponent {

  @Input() requestItemsNo: number | undefined
  @Input() purchaseItemsNo: number | undefined
  @Input() hasPriceProduct: boolean | undefined
  @Input() totalPrice: Price | undefined
}
